import { render } from "./PopularServiceIcon.vue?vue&type=template&id=4c12f00e&scoped=true"
import script from "./PopularServiceIcon.vue?vue&type=script&lang=js"
export * from "./PopularServiceIcon.vue?vue&type=script&lang=js"

import "./PopularServiceIcon.vue?vue&type=style&index=0&id=4c12f00e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c12f00e"]])

export default __exports__